import { render, staticRenderFns } from "./CertifyCation.vue?vue&type=template&id=89ee5660&scoped=true&"
import script from "./CertifyCation.vue?vue&type=script&lang=js&"
export * from "./CertifyCation.vue?vue&type=script&lang=js&"
import style0 from "./CertifyCation.vue?vue&type=style&index=0&id=89ee5660&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "89ee5660",
  null
  
)

export default component.exports